import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly defaultDuration = 4000;

  showSuccess(message: string, duration?: number): void {
    this.openSnackBar(message, duration, ['snack-success']);
  }

  showError(message: string, duration?: number): void {
    this.openSnackBar(message, duration, ['snack-error']);
  }

  showWarning(message: string, duration?: number): void {
    this.openSnackBar(message, duration, ['snack-warning']);
  }

  showInfo(message: string, duration?: number): void {
    this.openSnackBar(message, duration, ['snack-info']);
  }

  private openSnackBar(message: string, duration?: number, panelClass: string[] = []): void {
    const config: MatSnackBarConfig = {
      duration: duration ?? this.defaultDuration,
      panelClass,
      horizontalPosition: 'right',
      verticalPosition: 'top',
    };
    this.snackBar.open(message, undefined, config);
  }
}